import { Paper, TableContainer } from '@mui/material';

export default function StyledTableContainer({ children }) {
  return (
    <TableContainer component={Paper}>
      {children}
    </TableContainer>
  );
}
